import {Component, OnInit, OnDestroy, Output} from '@angular/core';
import {faDesktop, faUserSecret, faToolbox, faUserLock, faBuilding, faShareAlt} from '@fortawesome/free-solid-svg-icons';

import {ModuleModel, AcabimUser, NavigationModel} from '@cas-hub/acabim-common-client';
import {Subscription} from 'rxjs';

@Component({
    template: `<acabim-main-layout [navItems]="navItems" [module]="module"></acabim-main-layout>`
})
export class AcabimUserLayoutComponent implements OnInit, OnDestroy {

    authServiceSub: Subscription = new Subscription();
    user: AcabimUser | null = null;
    @Output() isAdmin = false;
    @Output() isSuperAdmin = false;

    public readonly module: ModuleModel = {
        title: 'User profile',
        description: 'Manage your user details',
        key: 'user',
        topNav: true,
        projectShow: false,
        projectOpen: false,
        projectSelect: false,
        projectLabel: 'Project'
    };

    public navItems: NavigationModel[] = [
        {
            title: 'Profile',
            link: './profile',
            icon: faDesktop
        },
        {
            title: 'Password',
            link: './password',
            icon: faUserSecret
        },
        {
            title: 'Privacy',
            link: './privacy',
            icon: faUserLock
        },
        {
            title: 'Shared Resources',
            link: './shared-resources',
            icon: faShareAlt
        },
        {
            title: 'Organisation',
            link: './organisation',
            icon: faBuilding,
            permissions: ['superOnly']
        },
        {
            title: 'Admin Space',
            link: './administration',
            icon: faToolbox,
            permissions: ['admin']
        }
    ];

    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy() {}
}
